import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
export default function BecomeAgentMonthlyCommission() {
  const data = promotionsData.find((promo) => promo.title === "Become an Agent")
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  // Table Data Incase
  const tableData = [
    { mechanics: "₱10 million", additionalGift: "₱500,000", bonus: "5.00%" },
    { mechanics: "₱9 million", additionalGift: "₱405,000", bonus: "4.50%" },
    { mechanics: "₱8 million", additionalGift: "₱320,000", bonus: "4.00%" },
    { mechanics: "₱7 million", additionalGift: "₱245,000", bonus: "3.50%" },
    { mechanics: "₱6 million", additionalGift: "₱180,000", bonus: "3.00%" },
    { mechanics: "₱5 million", additionalGift: "₱145,000", bonus: "3%" },
    { mechanics: "₱4 million", additionalGift: "₱112,000", bonus: "2.80%" },
    { mechanics: "₱3 million", additionalGift: "₱81,000", bonus: "3%" },
    { mechanics: "₱2 million", additionalGift: "₱52,000", bonus: "2.60%" },
    { mechanics: "₱1 million", additionalGift: "₱25,000", bonus: "3%" },
  ]

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Become an Agent</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Become an Agent</h1>
                <h2>Earn up to 40% Monthly Commission</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>Monthly Promotion</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong>Mechanics: </strong>
                <p>
                  Become an AGENT in FGH ONLINE CASINO and EARN BIGTIME with our
                  GGR-based commission model:
                </p>
                <label>Commission Structure:</label>
                <ul>
                  <li>
                    <p>
                      Agents receive a monthly commission based on Net Gaming
                      Revenue (NGR), where:
                    </p>
                  </li>
                  <li>
                    <p>
                      NGR = GGR – Jackpot Contribution – Bonuses – Cashback –
                      Referral Fees – Promotion Costs.
                    </p>
                  </li>
                </ul>
                <label>Commission Tiers:</label>
                <ul>
                  <li>
                    <p>30% commission for GGR below ₱100 million</p>
                  </li>
                  <li>
                    <p>35% commission for GGR between ₱100–200 million</p>
                  </li>
                  <li>
                    <p>40% commission for GGR of ₱200 million and above</p>
                  </li>
                </ul>
                <label>Luxurious Quarterly Gifts & Additional Bonuses</label>
                <p>
                  Unlock access to premium rewards like luxury vacations,
                  gadgets, and exquisite dining based on quarterly GGR
                  performance:
                </p>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0px" }}
                  >
                    <thead>
                      <th>Quarterly GGR</th>
                      <th>Additional Gift</th>
                      <th>Bonus%</th>
                    </thead>
                    <tbody>
                      {tableData.map((row, index) => (
                        <tr key={index}>
                          <td>{row.mechanics}</td>
                          <td>{row.additionalGift}</td>
                          <td>{row.bonus}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <strong>Terms & Conditions:</strong>
                <p>
                  Contact FGH Admin to get started and for full program details.
                </p>
                <ul>
                  <li>
                    <p>
                      This program runs monthly while rewards or additional
                      gifts are based on GGR performance within each quarter.
                    </p>
                  </li>
                  <li>
                    <p>
                      Eligible agents will be notified via email at the end of
                      the quarter with reward details and redemption
                      instructions.
                    </p>
                  </li>
                  <li>
                    <p>Prizes are non-transferable.</p>
                  </li>
                  <li>
                    <p>
                      Agents may opt to convert their reward to cash (80% of max
                      unit cost).
                    </p>
                  </li>
                  <li>
                    <p>
                      Agents who choose not to convert to cash must submit
                      documentation (e.g., photos or videos). Faces may be
                      blurred; no personal info is required.
                    </p>
                  </li>
                  <li>
                    <p>
                      Only verified agents can promote FGH and receive earnings.
                    </p>
                  </li>
                  <li>
                    <p>
                      Agent commission will be
                      <b> credited by the 5th day of each month.</b>
                    </p>
                  </li>
                  <li>
                    <p>
                      If all referred players win (positive gross win-loss), no
                      commission will be paid for that month. Losses will be
                      carried forward.
                    </p>
                  </li>
                  <li>
                    <p>
                      Agents must maintain a minimum of 5 active players to
                      qualify for commissions.
                    </p>
                  </li>
                  <li>
                    <p>
                      FGH Management has the final authority on all calculations
                      and compliance checks.
                    </p>
                  </li>
                  <li>
                    <p>
                      Commissions can be revoked in case of fraud or policy
                      violations.
                    </p>
                  </li>
                </ul>
                <div className="promotion-tnc-cta">
                  <a
                    href="https://telegram.me/fungaminghubph"
                    className="promotion-cta-btn"
                  >
                    Apply now in Telegram
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
